import { AbilityBuilder } from "@casl/ability";

function buildRulesFromPermissions(permissions = []) {
  const { can, rules } = AbilityBuilder.extract();

  (permissions || []).forEach((permission) => {
    if (permission?.action != null && permission?.subject != null) {
      can(permission.action, permission.subject);
    }
  });

  return rules;
}

const ability = AbilityBuilder.define((can) => {
  const storedRoles = localStorage.getItem("bonian_provider_roles");
  if (!storedRoles) return;

  const permissions = JSON.parse(storedRoles)?.permissions || [];
  permissions.forEach((permission) => {
    if (permission?.action != null && permission?.subject != null) {
      can(permission.action, permission.subject);
    }
  });
});

export function updateAbilityFromPermissions(permissions) {
  ability.update(buildRulesFromPermissions(permissions));
}

export function clearAbility() {
  ability.update([]);
}

export default ability;
